import { render } from "./Supplier_edit.vue?vue&type=template&id=4934a4d8"
import script from "./Supplier_edit.vue?vue&type=script&lang=js"
export * from "./Supplier_edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__